import React, { useState } from 'react';
import { FaListUl } from 'react-icons/fa';
import { useSteps } from '../../contexts/stepContext';
import { useAppTranslation } from '../../hooks/useAppTranslation';
import { useWizardSteps } from '../../hooks/useWizardSteps';
import AppFooter from '../AppFooter';
import AppHeader from '../AppHeader';
import Steps from '../Steps';
import Summary from '../Summary';
import {
  Aside,
  Container,
  Main,
  StepMeta,
  StepNav,
  StepNavInner,
  SummaryButton,
} from './styles';

const BodyStep: React.FC = ({ children }) => {
  const { flowStarted } = useSteps();
  const { translationPage } = useAppTranslation();
  const { tp } = translationPage(tr => tr.components.bodyStep);
  const { tp: tpSummary } = translationPage(tr => tr.components.summary);
  const { steps, currentIndex } = useWizardSteps();

  const [showSummary, setShowSummary] = useState(false);

  const showStepMeta = flowStarted && currentIndex >= 0;

  return (
    <Container>
      <AppHeader />

      {flowStarted && (
        <StepNav>
          <StepNavInner>
            <Steps />
            {showStepMeta && (
              <StepMeta>
                {tp('stepMeta', {
                  current: String(currentIndex + 1),
                  total: String(steps.length),
                })}
              </StepMeta>
            )}
            <SummaryButton type="button" onClick={() => setShowSummary(true)}>
              <FaListUl size={13} />
              {tpSummary('openButton')}
            </SummaryButton>
          </StepNavInner>
        </StepNav>
      )}

      <Main hasAside={flowStarted}>
        {children}
        {flowStarted && (
          <Aside>
            <Summary />
          </Aside>
        )}
      </Main>

      <AppFooter />

      {showSummary && <Summary asModal onClose={() => setShowSummary(false)} />}
    </Container>
  );
};

export default BodyStep;
